import { mdiFinance } from '@mdi/js'

export default [
  {
    title: 'Menu.Financial',
    icon: mdiFinance,
    resource: 'all',
    action: 'can_see_financial_menu',
    children: [
      // {
      //   to: 'bank-accounts',
      //   title: 'Menu.BankAccount',
      //   resource: 'all',
      //   action: 'can_see_financial_menu',
      // },
    ],
  },
]
